import React, { Fragment } from 'react'

import TextField from '@material-ui/core/TextField'

/* atoms */
import { Invalid } from '../feedbacks'
/* atoms */

/*
: properties
name,
label,
value,
onChange,
helperText,
error
*/

const numberMax4 = (props) => {
  
  const disabled = props.disabled ? true : false
  return (
    <Fragment>
      <TextField
        id="standard-full-width"
        {...props}
        disabled={disabled}
        fullWidth
        variant="outlined"
        margin="dense"
        inputProps={{ maxLength: 4, fontFamily: 'SubwaySixInch' }}
        InputLabelProps={{ style: { color: 'grey' } }}
      />
      <Invalid {...props} />
    </Fragment>
  )
}

export default numberMax4
